import dynamic from 'next/dynamic';

/**
 * The express wallets are client-only (they interrogate the browser/OS for wallet availability)
 * and pull in the Adyen SDK, so they are kept out of the main PDP bundle and off the server
 * render. The block renders nothing until both wallets report availability, so there is no
 * layout shift cost to loading it late.
 *
 * Shared by the two surfaces that mount it, the page CTA and the options drawer, so they cannot
 * drift on chunk name or SSR behaviour.
 */
export const ExpressCheckoutLazy = dynamic(
  () =>
    import(/* webpackChunkName: "express_checkout" */ './ExpressCheckoutContainer').then(
      (mod) => mod.ExpressCheckoutContainer,
    ),
  { ssr: false },
);
